import React from "react";
import "./style.scss";
import { useHistory } from "react-router-dom";
import { deleteActionApp } from "../../../services/graphs/actions";
// import { FaSort, FaChevronRight } from "react-icons/fa";
import { connect, useDispatch } from "react-redux";
import { updateApp } from "../../../services/filters/actions";
import swal from "sweetalert";

const AssignedActions = ({ data, deleteActionApp }) => {
  const dispatch = useDispatch();
  const history = useHistory();
  const apiKeyStyle = {
    width: "180px",
    fontSize: "1rem",
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
  };

  const selectApp = async (el) => {
    if (el.PLATFORM === "Google") el.PLATFORM = "GoogleAction";
    localStorage.setItem("platform", el.PLATFORM);
    dispatch(
      updateApp({
        platform: el.PLATFORM,
        apiKey: el.API_KEY_U,
        name: el.APP_NAME,
        environment: el.ENVIRONMENT,
      })
    );
    // swal("App Updated", "success").then(() => history.push("/dashboard"));
    history.push("/dashboard");
  };

  const copy = (id) => {
    // let input = document.getElementById(id);
    let input = document.createElement("input");
    input.value = id;
    document.getElementById("copy-to-clipboard").appendChild(input);
    input.select();
    document.execCommand("copy");
    document.getElementById("copy-to-clipboard").removeChild(input);
    // input.focus();
  };
  const deleteApp = async (el) => {
    let isConfirm = await swal({
      title: "Delete App",
      text: "Are you confirm to delete the app?",
      icon: "warning",
      buttons: ["No, cancel it!", "Yes, I am sure!"],
      dangerMode: true,
    });
    if (isConfirm) {
      await deleteActionApp(el);
      await swal(
        "App Deleted",
        "Your app has been deleted successfully",
        "success"
      );
    }
  };

  return (
    <>
      <table
        className="assigned_actions_container"
        id="assigned_actions_container"
      >
        <tbody>
          <tr className="header">
            <th>Apps Name</th>
            <th>Platform</th>
            <th>Environment</th>
            <th>API Key</th>
            <th></th>
          </tr>
          {data.map((el, key) => (
            <tr key={`app-${key}`}>
              <td className="title">
                {/* eslint-disable-next-line */}
                <a onClick={() => selectApp(el)}>
                  <div>
                    <b className="app-name-actions">{el.APP_NAME}</b>
                  </div>
                </a>
              </td>
              <td className="due" style={{ color: "#000" }}>
                {el.PLATFORM}
              </td>
              <td className="due" style={{ color: "#000" }}>
                {el.ENVIRONMENT}
              </td>
              <td className="user">
                <div>
                  <div style={apiKeyStyle} id={"api-" + el.id}>
                    {el.API_KEY_U}
                  </div>
                  <div
                    className="app-name-actions"
                    onClick={() => copy(el.API_KEY_U)}
                  >
                    Copy to Clipboard
                  </div>
                </div>
              </td>
              <td className="due">
                <span className="app-delete-btn" onClick={() => deleteApp(el)}>
                  Delete
                </span>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
      <div id="copy-to-clipboard"></div>
    </>
  );
};

// const mapStateToProps = (state) => ({
//   page: state.pageState.page,
// });
export default connect(null, { deleteActionApp })(AssignedActions);
